module.exports = __webpack_public_path__ + "img/integrations-wordpress-wtd.61b879a5.png";